import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";

interface MealReviewsProps {
  mealId: string;
}

export const MealReviews = ({ mealId }: MealReviewsProps) => {
  const { data: reviews, isLoading } = useQuery({
    queryKey: ['reviews', mealId],
    queryFn: async () => {
      const { data, error } = await supabase
        .from('reviews')
        .select(`
          *,
          user:profiles!reviews_user_id_fkey (
            first_name,
            last_name
          )
        `)
        .eq('meal_id', mealId);

      if (error) throw error;
      return data || [];
    }
  });

  if (isLoading) {
    return <div>Loading reviews...</div>;
  }

  return (
    <div className="space-y-4">
      <h3 className="text-lg font-semibold">Reviews</h3>
      {reviews?.length === 0 ? (
        <p className="text-muted-foreground">No reviews yet.</p>
      ) : (
        <div className="space-y-4">
          {reviews?.map((review) => (
            <div key={review.id} className="border-b pb-4">
              <div className="flex justify-between items-start">
                <div>
                  <p className="font-medium text-black">
                    {review.user?.first_name && review.user?.last_name 
                      ? `${review.user.first_name} ${review.user.last_name}`
                      : 'Anonymous User'}
                  </p>
                  <p className="text-sm text-gray-500">
                    {new Date(review.created_at).toLocaleDateString()}
                  </p>
                </div>
                <div className="text-yellow-400">
                  {review.rating} ★
                </div>
              </div>
              {review.comment && (
                <p className="mt-2 text-black">{review.comment}</p>
              )}
            </div>
          ))}
        </div>
      )}
    </div>
  );
};